import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import * as DateHelpers from './DateHelpers';
import ConfirmPopups from './ConfirmPopup';

interface ItemTask {
    id: number;
    jobQuoteItemId: number;
    installPickupDateFormatted: string;
    scheduleDate: string;
    scheduleDateFormatted: string;
    typeId: number;
    type: string;
    jobId: number;
    siteAddress: string;
    customer: string;
    customerEmail: string;
    itemId: number;
    item: string;
    unitNumber: string;
    complete: boolean
}

const ItemTaskData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [itemTasks, setItemTasks] = React.useState<ItemTask[]>([]);
    const [itemIndex, setItemIndex] = React.useState(-1);
    const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData();
    }, []);

    const getData = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=ViewItemTasks&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                getItemTasks();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }


    const getItemTasks = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get("api/ItemTask/GetItemTasks?SubId=" + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setItemTasks(res.data);
            setLoading(false);
        }).catch(error => {
            toast.error(error.message);
        });
    }

    const onTaskDateChange = (e: any, itemIndex: number) => {
        var items = [...itemTasks];
        var item = items[itemIndex];
        item.scheduleDate = e.target.value;
        setItemTasks(items);
        updateItem(item.id, e.target.value);
    }

    const updateItem = async (id: number, scheduleTaskDate: string) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var updateTaskItem = {
            id: id,
            scheduleTaskDate: scheduleTaskDate,
            subId: user.sub
        };

        axios.post('api/ItemTask/UpdateItemTask', updateTaskItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Task Updated Successfully");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const onUnitNoChange = (e: any, itemIndex: number) => {
        var items = [...itemTasks];
        var item = items[itemIndex];
        item.unitNumber = e.target.value;
        setItemTasks(items);
        saveItem(item.id, item.complete, e.target.value);
    }

    const onCellCheckboxChange = (e: any, itemIndex: number) => {
        var items = [...itemTasks];
        var item = items[itemIndex];
        item.complete = e.target.checked;
        setItemTasks(items);
        saveItem(item.id, e.target.checked, item.unitNumber);
    }

    const saveItem = async (id: number, complete: boolean, unitNo: string) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var saveItem = {
            id: id,
            complete: complete,
            unitNumber: unitNo,
            subId: user.sub
        };

        axios.post('api/ItemTask/SaveItemTask', saveItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Task Saved Successfully");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //DELETE ITEM
    const deleteItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        setItemIndex(itemIndex);
        setShowConfirmDelete(true);
    }

    const hideConfirmDelete = () => {
        setItemIndex(-1);
        setShowConfirmDelete(false);
    }

    const saveDelete = () => {
        saveDeleteTask();
    }

    const saveDeleteTask = async () => {
        var items = [...itemTasks];
        var item = items[itemIndex];

        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var deleteItem = {
            id: item.id,
            subId: user.sub
        };

        axios.post('api/ItemTask/DeleteItemTask', deleteItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                items.splice(itemIndex, 1);
                setItemTasks(items);
                setItemIndex(-1);
                setShowConfirmDelete(false);
                toast.success("Task Deleted Successfully");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });     
    }
    //END DELETE ITEM

    const minDate = DateHelpers.addDaysToCurrentDate(-7);
    const confirmDelete = <ConfirmPopups heading="Delete Task" text="Are you sure you want to delete this task?" showConfirmModal={showConfirmDelete} hideConfirmModal={hideConfirmDelete} saveConfirmModal={saveDelete} />

    const renderDetails = (
        <div>
            <div>
                {confirmDelete}
            </div>
            <div className="overflowAuto marginTop10">
                <table className="table tableColours">
                    <thead>
                        <tr>
                            <th className="hidden">Id</th>
                            <th>
                                <div className="tooltipitem tooltipitem__right">Schedule Date
                                    <span className="tooltipitemtext tooltipitemtext__right">Date that the Task is scheduled for</span>
                                </div>
                            </th>
                            <th>Type</th>
                            <th>
                                <div className="tooltipitem tooltipitem__right">Install/Pickup Date
                                    <span className="tooltipitemtext tooltipitemtext__right">Date that the Item was Installed or Picked up</span>
                                </div>
                            </th>
                            <th>Site Address</th>
                            <th>Customer</th>
                            <th>Customer Email</th>
                            <th>Item</th>
                            <th>Unit #</th>
                            <th className="textaligncenter">Complete</th>
                            <th></th>
                        </tr>
                    </thead>
                    {itemTasks.map((item, index) =>
                        <tbody key={index}>
                            <tr>
                                <td className="hidden">{item.id}</td>
                                <td className="table__text--align">
                                    <input type='date' min={minDate} className="form-control allocate__dateSize" value={item.scheduleDate} onChange={(e) => onTaskDateChange(e, index)} />
                                </td>
                                <td className="table__text--align">{item.type}</td>
                                <td className="table__text--align">{item.installPickupDateFormatted}</td>
                                <td className="table__text--align">{item.siteAddress}</td>
                                <td className="table__text--align">{item.customer}</td>
                                <td className="table__text--align">{item.customerEmail}</td>
                                <td className="table__text--align">{item.typeId === 4 ? "" : item.item}</td>
                                <td className="table__text--align">
                                    <input type='text' id="unitNumber" name="unitNumber" className={item.typeId > 2 ? "hidden" : "form-control allocate__size100"} value={item.unitNumber} onChange={(e) => onUnitNoChange(e, index)}  />
                                </td>
                                <td className="table__text--align">
                                    <input type='checkbox' id="complete" name="complete" className="alignIconCenter" checked={item.complete} onChange={(e) => onCellCheckboxChange(e, index)} />
                                </td>
                                <td>
                                    <div className="delete--tablecell">
                                        <a className="makeitred" href="#" onClick={(e) => deleteItem(e, index)}>
                                            <span className="fas fa-times-circle delete--icon alignIconCenter"></span>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    );
}

export default ItemTaskData;